





































import { Component, Prop } from 'vue-property-decorator';
import { MapStore } from '@/store/map';
import { getModule } from 'vuex-module-decorators';
import { Checkbox } from '@/components/forms';
import { WidgetGeneric } from './WidgetGeneric';
import { MarkerTemplateParams, WidgetConfig } from '@/models/widget-config.model';
import { Radio } from '@/components/forms';
import WidgetJobs from '@/components/widgets/WidgetJobs.vue';

@Component({
  components: { Checkbox, Radio, WidgetJobs }
})
export default class WidgetEconomicEcosystem extends WidgetGeneric {
  @Prop({ required: true, default: [] }) readonly checkboxes!: Record<string, any>[];
  @Prop({ required: true }) readonly closeOpenSubCategories!: () => void;
  @Prop({ required: true }) readonly unselectCategory!: (category: string, type: string) => void;

  jobsWidget = false;

  created(): void {
    this._mapStore = getModule(MapStore, this.$store);
    this._points = new Map();
    this._widgetType = 'ECONOMIC_ECOSYSTEM';
    this._config = this._createConfig();
  }

  beforeDestroy(): void {
    this.checkboxes.forEach((checkbox: any) => {
      checkbox.selected = false;
      if (checkbox.open) checkbox.open = false;
      if (checkbox.subCat) {
        checkbox.subCat.forEach((el: any) => {
          el.selected = false;
        });
      }
    });
    this._beforeDestroy();
  }

  disableOtherWidgets(type: string): void {
    if (type === 'JOBS') {
      this._mapStore.removeLayer({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
      this._mapStore.removeSource({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
      this._mapStore.setRecruitmentPoolWidget(false);
      this.unselectCategory('economicEcosystem', 'RECRUITMENT_POOL');
    }
    if (type === 'RECRUITMENT_POOL') {
      this._mapStore.removeLayer({ type: 'JOBS' });
      this._mapStore.removeSource({ type: 'JOBS' });
      this._removeEmploiPopup();
      this.unselectCategory('economicEcosystem', 'JOBS');
      this._mapStore.setSelectedPopupEmploi(null);
    }
    if (this._mapStore.airQualityModal) {
      this._mapStore.setAirQualityModal(false);
      this.unselectCategory('environnement', 'air-quality');
    }
    if (this._mapStore.greenSpacesModal) {
      this._mapStore.setGreenSpacesModal(false);
      this.unselectCategory('environnement', 'green-spaces-environment');
    }
  }

  change({ type, value }: { type: string; value: boolean }) {
    if (type === 'COMPANIES-ADMINISTRATIONS') {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) {
          this._points.get(table)!.visibility = value;
        }
      });
    } else if (this._points.has(type)) this._points.get(type)!.visibility = value;

    if (type === 'JOBS') {
      if (value) {
        this._mapStore.setSelectedPopupEmploi('laMeuse');
        this._addMapIsohrone(type);
        this.disableOtherWidgets(type);
      } else {
        this._mapStore.setSelectedPopupEmploi(null);
        this._mapStore.removeLayer({ type });
        this._mapStore.removeSource({ type });
        this._removeEmploiPopup();
      }
    }

    if (type === 'RECRUITMENT_POOL') {
      if (value) {
        this._addToMapFromMapboxPopulation();
        this.disableOtherWidgets(type);
      } else {
        this._mapStore.removeLayer({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
        this._mapStore.removeSource({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
      }
    }
    if (type === 'COMPANIES-ADMINISTRATIONS') {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) this._addToMap();
        else this._getPoints(table).then(() => this._addToMap());
      });
    } else if (['big-enterprises', 'small-medium-enterprises'].includes(type)) {
      if (this._points.has(type)) this._addToMap();
      else if (this._config[type].tableName) this._getPoints(type).then(() => this._addToMap());
    }

    // check if RecruitmentPool is checked
    const jobsWidget = this._points.get('JOBS');
    if (type === 'RECRUITMENT_POOL') {
      this._mapStore.setRecruitmentPoolWidget(value);
    }
    this.jobsWidget = jobsWidget && jobsWidget.visibility;
  }

  private _createConfig(): WidgetConfig {
    const config: any = {};
    this.checkboxes.forEach((checkbox: Record<string, any>) => {
      config[checkbox.type] = { marker: WidgetEconomicEcosystem._markerTemplate, tableName: checkbox.type };
      if (checkbox.subCat) {
        config[checkbox.type].tableNames = checkbox.subCat.map((el: any) => {
          config[el.type] = { marker: WidgetEconomicEcosystem._markerTemplate };
          return el.type;
        });
      }
    });
    return config;
  }
  private static _markerTemplate({ type, Total }: MarkerTemplateParams): HTMLDivElement {
    const markerElement = document.createElement('div');
    if (type === 'JOBS') {
      markerElement.innerHTML = `<div class="content background-color">
              <div class="jobs"></div>
              <h3 style="font-family: Montserrat,serif;
              font-size: 14px;color: #ffffff; font-weight: bold;" class="popup__title">${Total.toString().replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ' '
              )}</h3>
      </div>`;
    } else {
      // markerElement.className = `marker-economic-ecosystem marker-economic-ecosystem--${type.toLowerCase()}`;
      markerElement.classList.add(
        'marker-economic-ecosystem',
        `marker-economic-ecosystem--${type.toLowerCase()}`,
        'background-color'
      );
    }

    return markerElement;
  }
  destroyed(): void {
    this._mapStore.removeLayer({ type: this._widgetType });
    this._mapStore.removeSource({ type: this._widgetType });
    this._mapStore.removeLayer({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
    this._mapStore.removeSource({ type: 'ECONOMIC_ECOSYSTEM_MULTIPOLYGON' });
    this._mapStore.removeLayer({ type: 'JOBS' });
    this._mapStore.removeSource({ type: 'JOBS' });
    this._removeEmploiPopup();
  }
}
